import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { DATE_FORMAT } from '../../../constants/constants';
import { TruncateText } from '../../../helpers/strings';
import Button from '../../Common/Button';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import Moment from 'moment';
import Icon from '../../Common/Icon';
import './MissedMilestones.scss';

class MissedMilestones extends React.Component {
	constructor(props, context) {
		super(props, context);
		this._isMounted = false;

		this.state = {
			isLoading: true,
			showMore: false,
			searchParams: {
				pageSize: 15,
				pageNumber: 1,
				sortDir: 'desc',
				sortBy: 'targetDate',
			},
			tasks: [],
		};
	}

	componentDidMount = async () => {
		this._isMounted = true;
		await this.loadTasks();
	};

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidUpdate = async (prevProps) => {
		if (this.props.settings && this.props.settings !== prevProps.settings) {
			await this.loadTasks(false);
		}
	};

	loadTasks = async (combineResults) => {
		if (this.props.settings) {
			if (this._isMounted) this.setState({ isLoading: true });
			try {
				let params = this.state.searchParams;
				params.settings = this.props.settings;

				const response = await this.props.companyDashboardActions.loadMissedMilestones(params);
				if (this._isMounted && response.type === types.LOAD_MISSED_MILESTONES_SUCCESS) {
					if (response.payload.results) {
						const showMore = response.payload.results.length < this.state.searchParams.pageSize ? false : true;
						const combinedTasks = combineResults ? this.state.tasks.concat(response.payload.results) : response.payload.results;
						this.setState({ tasks: combinedTasks.slice(), showMore: showMore });
					} else {
						this.setState({ tasks: [] });
					}
				} else if (this._isMounted && response.type === types.LOAD_MISSED_MILESTONES_FAILURE) {
					Notification('error', 'Error', response.payload.message);
				}
			} catch (error) {
				if (this._isMounted) Notification('error', 'Error', error);
			} finally {
				if (this._isMounted) this.setState({ isLoading: false });
			}
		}
	};

	onShowMore = () => {
		const newPageNumber = this.state.searchParams.pageNumber + 1;
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: newPageNumber } }, () => this.loadTasks(true));
	};

	render() {
		const now = new Moment();

		return (
			<Fragment>
				<hr />
				<LoadingIndicator isLoading={this.state.isLoading}>
					{this.state.tasks.map((task) => {
						return (
							<div key={task.id} className='missed-milestones'>
								<div className='pb-2 d-flex align-items-center justify-content-between'>
									<div className='d-flex align-items-center'>
										<Icon name='calendar-alt' className='me-2' />
										<span className='text-danger me-2'>{Moment.utc(task.targetDate).format(DATE_FORMAT)}</span>
										<span className='days-ago'>({Moment.utc(task.targetDate).diff(now, 'days') * -1} days ago)</span>
										<Icon name='user' className='ms-3 me-2' />
										{task.responsibleUserName ? <span>{task.responsibleUserName}</span> : <span>{task.jobTitleName}</span>}
									</div>
									<span className='text-end'>{task.locationName}</span>
								</div>
								<div className='pb-2'>
									<span
										className='description text-primary'
										onClick={() => this.props.onSelectTask(task.id, task.locationKey)}
										style={{ cursor: 'pointer' }}>
										{task.taskName}
									</span>
								</div>
								<div className='pb-2 d-flex align-items-center justify-content-between'>
									<div>
										{task.projectName && <span>{TruncateText(task.projectName, 45)} - </span>}
										{task.statusName}
									</div>
									{task.commentsAdded && (
										<span className='text-end' title='Comments Added'>
											<Icon name='comment' />
										</span>
									)}
								</div>
								<hr />
							</div>
						);
					})}
					{this.state.showMore && (
						<Button type='button' text='Show More' bootstrapClass='light float-end' name='showMore' onClick={this.onShowMore} />
					)}
				</LoadingIndicator>
			</Fragment>
		);
	}
}

MissedMilestones.propTypes = {
	companyDashboardActions: PropTypes.object.isRequired,
	onSelectTask: PropTypes.func.isRequired,
	settings: PropTypes.object.isRequired,
};

export default MissedMilestones;
